<button
  id="genericListButton-button-{{ buttonTitle | camelCase }}-{{ testingId | camelCase }}"
  mat-stroked-button
  color="{{ buttonColor }}"
  (click)="handleClick($event)"
  uzDebounceClick
  [disabled]="disabled"
>
  {{ buttonTitle }}
</button>
